import { Navigate, Outlet } from "react-router-dom";
import { useAuthSession } from "@/hooks/useAuthSession";

export default function ProtectedRoute() {
  const { session, loading } = useAuthSession();
  if (loading) return <div className="p-8 text-slate-500">Loading…</div>;
  if (!session) return <Navigate to="/login" replace />;
  return <Outlet />;
}
